import React from 'react';
import PropTypes from 'prop-types';

const ModalPadding = ({ children }) => (
  <div className="modal-padding">
    {children}
  </div>
);

ModalPadding.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
};

export default ModalPadding;



// WEBPACK FOOTER //
// ./library/app/components/Global/Modals/ModalPadding.js